import React from 'react';
import cartReducer, { defaultState } from '../reducers/cart-reducer';
import actionsCart from '../actions/cart';

const CartContext = React.createContext();

function useCartContextValue() {
    const [state, setState] = React.useReducer(cartReducer, defaultState);

    const { number, products, quantity, total, table, type, customers, payed, customer, deliveryCost, order_note } = state;

    const add = React.useCallback((item, quantity) => setState(actionsCart.add(item, quantity)), []);
    const remove = React.useCallback(id => setState(actionsCart.remove(id)), []);
    const addOne = React.useCallback(id => setState(actionsCart.addOne(id)), []);
    const subOne = React.useCallback(id => setState(actionsCart.subOne(id)), []);
    const clean = React.useCallback(() => setState(actionsCart.clean()), []);
    const setTable = React.useCallback(table => setState(actionsCart.setTable(table)), []);
    const setNumber = React.useCallback(number => setState(actionsCart.setNumber(number)), []);
    const setType = React.useCallback(type => setState(actionsCart.setType(type)), []);
    const addNote = React.useCallback((id, note) => setState(actionsCart.addNote(id, note)), []);
    const addOrderNote = React.useCallback((note) => setState(actionsCart.addOrderNote(note)), []);
    const setCustomers = React.useCallback(number => setState(actionsCart.setCustomers(number)), []);
    const setDeliveryCost = React.useCallback(deliveryCost => setState(actionsCart.setDeliveryCost(deliveryCost)), []);
    const setPayed = React.useCallback(bool => setState(actionsCart.setPayed(bool)), []);
    const setCustomer = React.useCallback(bool => setState(actionsCart.setCustomer(bool)), []);

    const value = React.useMemo(() => {
        return {
            number,
            products,
            quantity,
            table,
            total,
            type,
            customers,
            payed,
            add,
            remove,
            addOne,
            subOne,
            clean,
            customer,
            deliveryCost,
            order_note,
            setTable,
            setNumber,
            setType,
            addNote,
            addOrderNote,
            setCustomers,
            setDeliveryCost,
            setPayed,
            setCustomer,
        }
    }, [
        number, products, quantity, table, total, type, customers, payed, deliveryCost, order_note,
        add, remove, addOne, subOne, clean, customer, setTable, setNumber, setType, addNote, addOrderNote, setCustomers, setDeliveryCost, setPayed, setCustomer
    ]);

    return value;
}

function CartProvider(props) {
    const value = useCartContextValue();
    return <CartContext.Provider value={value} {...props} />;
}

function useCart() {
    const context = React.useContext(CartContext);
    if (!context) {
        throw new Error("useCart must be used within a CartProvider");
    }
    return context;
}

export { CartProvider, useCart }
